import NavLink from './NavLink'

function Navigation() {
  return (
    <nav className="fixed bottom-8 left-0 right-0 z-40 ">
      <div className="flex items-center justify-center gap-0 bg-white/70 backdrop-blur-lg py-2 px-2 rounded-full max-w-fit mx-auto border-2 border-gray-200 shadow-lg">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/work">Work</NavLink>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </div>
    </nav>
  )
}

export default Navigation
